const doc = [({"en":({"js":({"admin":({"supplier_supported_sheets":({"create_card":({"create_supplier_supported_sheet":"Create supported sheet for supplier"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;